export const mapping = {
  "slug": "routeSlug",
  "nodePage": "routeNodePage",
  "nodePressRelease": "routeNodePressRelease",
  "nodeCanonical": "routeNodeCanonical",
  "webform": "routeWebform"
}